import React from "react";
import { useTranslation } from "react-i18next";
import { Confirmation_ } from "monica-alexandria";
import { sharedContactConfirmationEvent } from "../utils/shared_contact_confirmation";

export const Shared_Contact_Confirmation = () => {
    const { t } = useTranslation();
    const [pending, setPending] = React.useState(null);
    const pendingRef = React.useRef(null);
    React.useEffect(() => {
        const receive = event => {
            if (event.detail.handled) return;
            event.detail.handled = true;
            if (pendingRef.current) return event.detail.resolve(false);
            pendingRef.current = event.detail;
            setPending(event.detail);
        };
        window.addEventListener(sharedContactConfirmationEvent, receive);
        return () => {
            window.removeEventListener(sharedContactConfirmationEvent, receive);
            pendingRef.current?.resolve(false);
            pendingRef.current = null;
        };
    }, []);

    const finish = confirmed => {
        const request = pendingRef.current;
        pendingRef.current = null;
        setPending(null);
        request?.resolve(confirmed);
    };

    if (!pending) return null;
    return <Confirmation_
        message={<>
            <span style={{ display: "block", maxHeight: "50vh", overflowY: "auto" }}>
                {(pending.matches || []).map(match => <span key={match.brandId} style={{ display: "block" }}>
                    {t("{{contacts}} already exists in {{leadName}} and {{brandName}}", {
                        contacts: [...(match.phones || []), ...(match.emails || [])].join(", "),
                        leadName: [match.firstName, match.lastName].filter(Boolean).join(" ") || t("Unnamed lead"),
                        brandName: match.brandName || t("Unnamed brand")
                    })}
                </span>)}
                {pending.hasMore ? <span>{t("More matching brands exist.")}</span> : null}
            </span>
            <span>{t("Do you want to continue?")}</span>
        </>}
        yes={t("Continue")}
        no={t("Cancel")}
        onYes={() => finish(true)}
        onNo={() => finish(false)}
        onClose={() => finish(false)}
    />;
};
